import { render, staticRenderFns } from "./sorting.vue?vue&type=template&id=6bbb7d9e&"
import script from "./sorting.vue?vue&type=script&lang=js&"
export * from "./sorting.vue?vue&type=script&lang=js&"
import style0 from "./sorting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports